import classNames from "classnames";

import Image from "components/imageNew/image";
import { formatDateEventCard } from "components/eventCard/utils";

import { TalkData } from "../../types";
import TalkRegistration from "../registration/talkRegistration/talkRegistration";
import { AddToCalendar } from "components/addToCalendar/addToCalendar";

type DetailHeroProps = TalkData & {};

const DetailHero = (talk: DetailHeroProps) => {
  const { title, dateTime } = talk;

  return (
    <div
      className={
        "flex flex-col gap-[14px] border-b-[#C8C8CC] md:border-b md:pb-[30px] lg:flex-row lg:gap-10 lg:pb-10"
      }
    >
      {talk.image && talk.image.url && (
        <div className={"flex w-full justify-center lg:w-auto"}>
          <div
            className={
              "margin-auto h-full max-h-[320px] w-full max-w-[320px] flex-none md:h-[240px] md:w-[240px]"
            }
          >
            <Image
              src={talk.image.url}
              alt={talk.image.alt || `${title} image`}
              width={talk.image.width}
              height={talk.image.height}
              blurDataURL={talk.image.blurUpThumb}
              className={"pointer-events-none h-full w-full object-cover"}
              sizes={"400px"}
            />
          </div>
        </div>
      )}
      <div className={"flex w-full flex-col justify-between"}>
        <div>
          <p
            className={
              "mb-2 font-bold text-[16px] leading-[130%] text-cerise lg:mb-1"
            }
          >
            {talk.marketLabel}
          </p>
          <h1
            className={
              "mb-[18px] font-recklessBold text-[18px] leading-[130%] md:text-[32px] lg:mb-3"
            }
          >
            {title}
          </h1>
          <div
            className={
              "flex flex-col justify-between gap-5 lg:flex-row lg:items-center"
            }
          >
            <div className={classNames("flex flex-row items-center")}>
              <p
                className={
                  "font-bold text-[14px] leading-[130%] text-mono-40 md:text-[16px]"
                }
              >
                {formatDateEventCard(new Date(dateTime), {
                  timezone: ["Europe/London", "Europe/Brussels"],
                  withDuration: true,
                  duration: talk.duration,
                })}
              </p>
              <AddToCalendar
                event={talk}
                classNames="text-[#767683] [&>span]:ml-md space-x-[20px]"
                type="talk"
              />
            </div>
          </div>
        </div>
        <div className={"mt-5"}>
          <TalkRegistration talk={talk} variant="singlePage" />
        </div>
      </div>
    </div>
  );
};

export default DetailHero;
